import Swal from 'sweetalert2';
import { ExportHistoryData } from '../../../../API/History/models';
import * as XLSX from 'xlsx';
import { getAllHistoryExport } from '../../../../API/History/History';
import { useState } from 'react';
import { HistoryFiltersForm } from '../History';

export const useExportHistory = ({ filters }: { filters: HistoryFiltersForm }) => {

    const [loadingExport, setLoadingExport] = useState(false)
    const exportToExcel = (data: ExportHistoryData[], cajero: string) => {
        // Extracting the required columns
        const excelData = data.map(({ date, creator, description, user_target, destinationAccountName, senderName, amount }) => {
            // Dividir la descripción en palabras
            const words = description.split(' ');
            // Extraer la acción que es la primera palabra
            const action = words[0];
            // Buscar el número en la descripción ignorando el nombre que puede tener números
            const quantity = parseInt(words.find(word => !isNaN(Number(word)) && parseInt(word)) ?? '');

            return {
                'Fecha': date,
                'Cajero': creator,
                'Acción': action,
                'Cantidad': amount ?? quantity,
                'Usuario': user_target,
                'Cuenta Destinatario': destinationAccountName,
                'Cuenta Remitente': senderName,
                'Detalle': description,
            };
        });

        // Creating a new workbook
        const wb = XLSX.utils.book_new();
        // Converting the data to a worksheet
        const ws = XLSX.utils.json_to_sheet(excelData);

        ws['!cols'] = [
            { wch: 15 }, // Fecha
            { wch: 20 }, // Cajero
            { wch: 10 }, // Acción
            { wch: 10 }, // Cantidad
            { wch: 20 }, // Usuario
            { wch: 25 }, // Cuenta Destinatario
            { wch: 25 }, // Cuenta Remitente
            { wch: 50 }, // Detalle
        ];

        // Adding the worksheet to the workbook
        XLSX.utils.book_append_sheet(wb, ws, 'History');

        // Writing the workbook to a file
        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

        // Convert string to a buffer
        const buffer = new ArrayBuffer(wbout.length);
        const view = new Uint8Array(buffer);
        for (let i = 0; i < wbout.length; i++) {
            view[i] = wbout.charCodeAt(i) & 0xff;
        }

        // Save the file
        let today = new Date().toLocaleDateString();
        const blob = new Blob([buffer], { type: 'application/octet-stream' });
        const fileName = `Historial ${cajero} ${today}.xlsx`;
        if (window.navigator.msSaveOrOpenBlob) {
            // For IE
            window.navigator.msSaveOrOpenBlob(blob, fileName);
        } else {
            // For other browsers
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            document.body.appendChild(a);
            a.href = url;
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
        }
    };


    const fetchDataToExport = async () => {
        if (filters.startDate && filters.endDate) {
            const startDate = new Date(filters.startDate);
            const endDate = new Date(filters.endDate);


            // Ensure both dates are valid
            if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
                Swal.fire({
                    icon: 'error',
                    text: "Fechas inválidas. Por favor, verifica las fechas seleccionadas."
                });
                return;
            }
            // Calculate difference in days
            const diffTime = Math.abs(endDate.getTime() - startDate.getTime());
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

            // Check if difference is more than 60 days (approximately 2 months)

            if (startDate > endDate) {
                Swal.fire({
                    icon: 'error',
                    text: "La fecha de inicio no puede ser mayor a la fecha de fin."
                });
                return;
            }

            if (diffDays > 60) {
                Swal.fire({
                    icon: 'error',
                    html: `La diferencia entre fecha de inicio y fecha de fin no puede ser mayor a 2 meses. 
                    <br/> <br/>
                    <span class="text-sm text-secondary">En caso de necesitar exportar períodos más largos contacta al administrador para obtener más detalles</span>`
                });
                return;
            }
        } else {
            Swal.fire({
                icon: 'error',
                html: "Debes seleccionar un rango de fechas para exportar. <br/> No puedes exportar un rango mayor a 2 meses."
            });
            return;
        }


        Swal.fire({
            title: 'Exportando, por favor espera...',
            allowOutsideClick: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        setLoadingExport(true);
        let cajero = filters.creatorName;
        const data = await getAllHistoryExport({ ...filters });
        if (data?.data) { exportToExcel(data.data, cajero) }
        setLoadingExport(false)
        Swal.close();


    };




    return { exportToExcel, loadingExport, fetchDataToExport }
}
